import { render, staticRenderFns } from "./AddProgress.vue?vue&type=template&id=1990d839"
import script from "./AddProgress.vue?vue&type=script&lang=js"
export * from "./AddProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports